import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Modal from "react-modal";
import { useState } from "react";
import closeModal from "../images/close.svg";
import ShowMoreText from "react-show-more-text";

const Project = ({
  technologies,
  title,
  image,
  color,
  id,
  github,
  deployed,
  description,
}) => {
  const [ref, inView] = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  const variants = {
    hidden: { x: id % 2 === 0 ? "10vw" : "-10vw", opacity: 0 },
    visible: { x: 0, opacity: 1 },
  };

  Modal.setAppElement("#root");

  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <motion.div
      ref={ref}
      className="col-sm-12 col-lg-6"
      variants={variants}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      <div
        style={{
          backgroundColor: color,
          borderRadius: "12px",
          overflow: "hidden",
          minHeight: "300px",
          cursor: "pointer",
        }}
        className="projectCard d-flex flex-column flex-md-row align-items-stretch justify-content-between mb-4 shadow"
        onClick={handleOpenModal}
      >
        <div className="col-12 col-md-6 p-4 d-flex flex-column justify-content-center">
          <p className="tech">
            <em>{technologies}</em>
          </p>
          <h3 className="projectTitle mb-2">{title}</h3>
          <span
            className="viewWork mt-2"
            style={{
              padding: "8px 16px",
              backgroundColor: "#00B4D8",
              borderRadius: "20px",
              color: "#fff",
              fontWeight: "500",
              fontSize: "0.95rem",
              width: "fit-content",
              boxShadow: "0px 2px 10px rgba(0, 180, 216, 0.3)",
            }}
          >
            View Project
          </span>
        </div>

        <div className="col-12 col-md-6 d-flex align-items-center justify-content-center p-3">
          <img
            src={image}
            alt={`${title} preview`}
            style={{
              maxWidth: "100%",
              maxHeight: "15vh",
              objectFit: "cover",
              borderRadius: "4px",
            }}
          />
        </div>
      </div>

      <Modal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        style={{
          overlay: {
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(0, 0, 0, 0.3)", // subtle dark overlay
            zIndex: 998,
          },
          content: {
            backgroundColor: "#1a1a1a",
            color: "#e0e0e0",
            padding: "40px",
            display: "flex",
            flexDirection: "column",
            width: "500px",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "12px",
            border: "1px solid #333",
            boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.5)",
          },
        }}
      >
        <img
          src={closeModal}
          className="closeMenu closeModal"
          onClick={handleCloseModal}
          alt="Close"
          style={{ width: "24px", alignSelf: "flex-end", cursor: "pointer" }}
        />

        <h3 style={{ marginBottom: "20px", color: "#00B4D8" }}>{title}</h3>

        <ShowMoreText
          more="Show more"
          less="Show less"
          anchorClass="show-more-less-clickable"
          expanded={false}
          width={400}
          className="projectDescription"
        >
          {description}
        </ShowMoreText>

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px" }}>
          <button
            className="btn"
            style={{
              padding: "10px 20px",
              backgroundColor: "#00B4D8",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontWeight: "500",
              cursor: "pointer",
              flex: 1,
              marginRight: "10px",
            }}
            onClick={() => window.open(github, "_blank")}
          >
            GitHub Repo
          </button>
          <button
            className="btn"
            style={{
              padding: "10px 20px",
              backgroundColor: "#06d6a0",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontWeight: "500",
              cursor: "pointer",
              flex: 1,
            }}
            onClick={() => window.open(deployed, "_blank")}
          >
            Live Site
          </button>
        </div>
      </Modal>
    </motion.div>
  );
};

export default Project;